import clsx from "clsx";
import React, { FC, PropsWithChildren, ReactNode } from "react";

import { ButtonGenericProps } from "./button-generic-props";
import { getButtonClassName } from "./get-button-class-name";

export interface ButtonProps
  extends Pick<
      React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>,
      "onClick" | "className" | "type" | "disabled"
    >,
    ButtonGenericProps {}

type TButtonWatermakProps = {
  children?: ReactNode;
  inverted?: boolean;
};

export const ButtonWatermark = ({ children, inverted = false }: TButtonWatermakProps) => {
  return (
    <div className={clsx("btn--watermark shadow-md", inverted && "btn--watermark--inverted")}>
      {children}
      <div className={"btn--watermark--plus"} />
    </div>
  );
};

export const Button: FC<PropsWithChildren<ButtonProps>> = ({
  variant = "neutral",
  size = "md",
  className: _className,
  children,
  fullWidth,
  disabled,
  ...props
}) => {
  const className = getButtonClassName({
    size,
    variant,
    fullWidth,
    disabled: disabled,
    customClassName: _className,
  });

  const btn = (
    <button className={className} type={props?.type ?? "button"} disabled={disabled} {...props}>
      {children}
    </button>
  );

  if (variant === "watermarked") {
    return <ButtonWatermark>{children}</ButtonWatermark>;
  }

  return btn;
};
